$(function() {
	 $('#dowxload_table_xlsx').click(function() {

			var tables 		=	$(".table_xlsx")		;
			var workbook 	=	XLSX.utils.book_new()	;

			for (var i = 0; i < tables.length; i++) {
				var worksheet = XLSX.utils.table_to_sheet(tables[i]);
				
				XLSX.utils.book_append_sheet(workbook,	worksheet,	"Sheet" + (i + 1));
			}

			XLSX.writeFile(workbook, "XDMS.xlsx");
    });
});